export const environment = {
  appHost: 'https://dev2.coverage.hub.veratrak.com',
  apiHost: 'https://xyo9xb8gm6.execute-api.eu-west-1.amazonaws.com/Prod',
  cognito: {
    region: 'eu-west-1',
    identityPoolId: 'eu-west-1:ec385742-9206-4cd0-8290-6293e8498b90',
    userPoolId: 'eu-west-1_m7R60FUmR',
    poolName: 'watchtower-dev2',
    clientId: '5j11sifl8qou3ahfvviib9plgt',
    redirect: 'https://dev2.coverage.hub.veratrak.com'
  }
};